<template>
  <div>
    <router-link
      :to="
        $route.query.branchId
          ? {
              path: `/Retail-Outlet/pump/transactions/${data.pumpId}`,
              query: {
                pumpId: data.pumpId,
                startDate: this.$route.query.startDate,
                endDate: this.$route.query.endDate,
                branchId: data.branchId,
                companyId: $route.query.companyId,
              },
            }
          : {
              path: `/Retail-Outlet/pump/transactions/${data.pumpId}`,
              query: {
                pumpId: data.pumpId,
                startDate: this.$route.query.startDate,
                endDate: this.$route.query.endDate,
                companyId: $route.query.companyId,
              },
            }
      "
      class="branchDetail_btn other_btn_4"
      >{{ data.viewTransactionsButton }}</router-link
    >
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
};
</script>
